import { AfterViewInit, Component, OnChanges, OnInit, SimpleChanges } from "@angular/core";
import { SelectItem } from "primeng/api";
import { DropdownChangeEvent } from "primeng/dropdown";
import { DashboardService, StripeInsightsMetricSeries } from "src/app/Services/dashboard.service";
import { StripeService } from "src/app/Services/stripe.service";
import { AdminDashboardApiResponce, AdminDashboardInsightMetrics, AdminDashboardInsightMetricsType, AdminSubscriptionInsightsMetricsColors, ArtistSalesInsightsMetrics, PrimengDataSet, StripeInsightsChart } from "src/app/models/response/artistoverlaydashboard.model";

@Component({
    selector: 'admin-insights-chart',
    templateUrl: './admin-insights-chart.component.html',
    inputs: ['insightsSeriesData', 'selectedTabIndex'],
    standalone: false
})

export class AdminInsightsChartComponent implements OnInit ,AfterViewInit, OnChanges{
    public selectedStripeDuration:  number = 365 ;
    public stripeDurationOptions: SelectItem[] = [
        { label: 'Last 1 week', value: 7 },
        { label: 'Last 1 month', value: 30 },
        { label: 'Last 3 months', value: 90 },
        { label: 'Last 6 months', value: 180 },
        { label: 'Last 1 year', value: 365 }
    ];
    public insightsStripeChartDataLoaded: boolean = false;
    public insightsStripeChartOptions!: any
    // public insightsSeriesData!: AdminDashboardApiResponce;
    // public insightsInputData!: StripeInsightsMetricSeries;
    public insightsSeriesData!: StripeInsightsChart;
    public insightsStripeChartData!: PrimengDataSet;
    public selectedDurationInDays: SelectItem = { label: 'Last 1 year', value: 365 };
    public selectedTabIndex!: number;
    
    constructor(private dashboardService:DashboardService){

    }
    ngOnChanges(changes: SimpleChanges): void {
        if(changes['insightsSeriesData'] && changes['insightsSeriesData'].isFirstChange()  && this.insightsSeriesData){
            // console.log("on changes",this.insightsSeriesData)
            this.onStripeDurationChange(this.insightsSeriesData);

        }
        if(changes['selectedTabIndex'] && !changes['selectedTabIndex'].isFirstChange()){
            // console.log(this.selectedTabIndex)
        }
    }
    ngAfterViewInit(): void {
        // this.onStripeDurationChange(this.selectedDurationInDays);
        setTimeout(()=>{
            this.getChartData(this.insightsSeriesData)
        },0)
    }
    ngOnInit(): void {
        // this.getChartsData()
        // this.getAllSubcription(this.selectedDurationInDays)
        const documentStyle = getComputedStyle(document.documentElement);
        const textColor = documentStyle.getPropertyValue('--text-color');
        const textColorSecondary = documentStyle.getPropertyValue('--text-color-secondary');
        const surfaceBorder = documentStyle.getPropertyValue('--surface-border');

        this.insightsStripeChartOptions = {
            maintainAspectRatio: false,
            aspectRatio: 0.6,
            plugins: {
                legend: {
                    labels: {
                        color: textColor,
                    }
                },
                tooltip: {
                    callbacks: {
                        //https://www.chartjs.org/docs/latest/configuration/tooltip.html#tooltip-callbacks
                        label: function (context: { dataset: { label: string; }; }) {
                            let label = context.dataset.label || '';
                            //you can add any customizations to the label here
                            return label;
                        },
                        title: function (tooltipItems: string | any[]) {
                            if (tooltipItems && tooltipItems.length > 0) {
                                var item = tooltipItems[0];
                                var index = item.dataIndex;
                                if (index >= 0 && item.dataset) {
                                    var dataset = item.dataset;
                                    console.log(dataset);
                                    return dataset.dataPointLabels[index] + ': ' + dataset.data[index];
                                }
                            }
                            return null;
                        }
                    }
                }
            },
        };
    }

    // public getAllSubcription(DurationDays: number){
    //     const documentStyle = getComputedStyle(document.documentElement);
    //     this.stripeService.getAllSubscriptions(DurationDays).subscribe((responce : PaidInvoices) =>{
    //         console.log(responce)
    //         this.insightsStripeChartData = {
    //             labels: responce.MonthlyInvoices.map((data)=>data.MonthYear),
    //             datasets: [
    //                 {
    //                     label: responce.MonthlyInvoices.map((data)=>data.MonthYear),
    //                     data: responce.MonthlyInvoices.map((data)=> data.TotalPaidAmount),
    //                     fill: true,
    //                     borderColor: documentStyle.getPropertyValue('--blue-500'),
    //                     tension: 0.4
    //                 }
    //             ]
    //         };
    //         if (responce && responce.MonthlyInvoices.length > 0) {
    //             responce.MonthlyInvoices.forEach(item => this.totalStripePaidInvoices += item.TotalPaidAmount);
    //             responce.MonthlyInvoices.forEach(item => this.totalStripeInvoices += item.InvoicesCount);
    //         }
    //         this.insightsStripeChartDataLoaded = true
    //     }, (error: any) => { console.error(error); this.insightsStripeChartDataLoaded = false; })
    // }

    // public getChartsData(){
    //     const documentStyle = getComputedStyle(document.documentElement);
    //         this.insightsStripeChartData = {
    //             labels: this.insightsSeriesData.map(p=>p.SeriesName),
    //             datasets: [
    //                 {
    //                 label: this.insightsSeriesData?.Metric,
    //                 data: this.insightsSeriesData?.ChartsValue.map(p=>p.Value),
    //                 fill: this.insightsSeriesData?.Metric == AdminDashboardInsightMetrics.TotalPaidInvoices ? true : false,
    //                 borderColor: documentStyle.getPropertyValue('--primary-color'),
    //                 tension: 0.4
    //             }
    //         ]
    //     };
    //     this.totalStripePaidInvoices = this.insightsSeriesData?.StripeInsights?.TotalPaidAmount
    //     this.totalStripeInvoices = this.insightsSeriesData?.StripeInsights?.TotalInvoice
    //     this.insightsStripeChartDataLoaded = true
    //     console.log(this.insightsStripeChartData)
    // }
    
    // public getChartsData(){
    //     const documentStyle = getComputedStyle(document.documentElement);
    //         this.insightsStripeChartData = [{
    //             labels: this.insightsSeriesData.map(p=>p.SeriesName),
    //             datasets: [
    //                 {
    //                 label: this.insightsSeriesData[0].SeriesName,
    //                 data: this.insightsSeriesData[0].ChartsValue,
    //                 fill: this.insightsSeriesData[0].Metric == AdminDashboardInsightMetrics.TotalPaidInvoices || this.insightsSeriesData[0].Metric == AdminDashboardInsightMetrics.TotalPaidInvoices,
    //                 borderColor: documentStyle.getPropertyValue('--primary-color'),
    //                 tension: 0.4
    //             }
    //         ]
    //     }];
    //     this.totalStripePaidInvoices = this.insightsSeriesData[0].TopSummaryStatus
    //     this.totalStripeInvoices = this.insightsSeriesData[0].TopSummaryStatus
    //     this.insightsStripeChartDataLoaded = true
    //     console.log(this.insightsStripeChartData)
    // }
    
    public getChartData(insightsSeriesData: StripeInsightsChart) {
        const documentStyle = getComputedStyle(document.documentElement);
        if (insightsSeriesData.ChartsValue) {
            this.insightsStripeChartData = {
                labels: insightsSeriesData.ChartsValue.map(p=>p.Label),
                datasets: [
                    {
                        label: insightsSeriesData.SeriesName,
                        data: insightsSeriesData.ChartsValue.map((data) => data.Value),
                        dataPointLabels: insightsSeriesData.ChartsValue.map((data)=>data.DataLabel),
                        fill: insightsSeriesData.Metric == AdminDashboardInsightMetrics.TotalPaidInvoiceAmount || insightsSeriesData.Metric == AdminDashboardInsightMetrics.TotalPaidInvoices,
                        borderColor: documentStyle.getPropertyValue(this.getSeriesColor(insightsSeriesData.Metric)),
                        tension: 0.4
                    },
                ],
            }
            // console.log("insightsStripeChartData",this.insightsStripeChartData)
            this.insightsStripeChartDataLoaded = true
        }

        // this.totalValues = insightsSeriesData.TopSummaryStatus

    }
     
    private getSeriesColor(seriesName: AdminDashboardInsightMetricsType): string {
        if (seriesName == AdminDashboardInsightMetrics.TotalPaidInvoiceAmount) {
            return AdminSubscriptionInsightsMetricsColors.TotalPaidInvoiceAmount;
        } else if (seriesName == AdminDashboardInsightMetrics.TotalPaidInvoices) {
            return AdminSubscriptionInsightsMetricsColors.TotalPaidInvoices;
        }
        return '--blue-500';
    }

    calculateTotalSales(): number {
        if (!this.insightsSeriesData || !this.insightsSeriesData.ChartsValue) {
            return 0;
        }
    
        return this.insightsSeriesData.ChartsValue.reduce((total, value) => total + value.Value, 0);
    }

    public onStripeDurationChange($event: any) {
        // console.log($event)
       if($event.value){
        const seletedValue = $event.value
        this.selectedStripeDuration = seletedValue
        // console.log(this.selectedStripeDuration)
        this.dashboardService.getSubscriptionDurationAdmin(this.selectedStripeDuration).subscribe((durationValue: StripeInsightsChart[]) =>{
            // console.log(durationValue)
            this.insightsSeriesData = durationValue[0];
            if(this.selectedTabIndex == 0 && durationValue.find(p=>p.Metric == AdminDashboardInsightMetrics.TotalPaidInvoiceAmount)){
                this.insightsSeriesData = durationValue[0]
                // console.log("[0]",this.insightsSeriesData)
            }else if(this.selectedTabIndex == 1 && durationValue.find(p=>p.Metric == AdminDashboardInsightMetrics.TotalPaidInvoices)){
                this.insightsSeriesData = durationValue[1]
                // console.log("[1]",this.insightsSeriesData)
            }
            
            this.getChartData(this.insightsSeriesData)
        })
       }
    }

    
}